import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { AlertConfirmationService } from 'ng-components-tsi';
import { PwaUpdateService } from '../../../pwa-update.service';

@Component({
  selector: 'app-update-notice',
  templateUrl: './update-notice.component.html',
  styleUrl: './update-notice.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateNoticeComponent {

  readonly pwaUpdate = inject(PwaUpdateService)
  private readonly alertConfirm = inject(AlertConfirmationService)

  readonly isUpdating = signal(false)

  async update(): Promise<void> {
    if (this.isUpdating()) return
    const confirmed = await this.alertConfirm.mostrarModalConfirmacion({
      texto: '¿Guardó sus cambios? La página se recargará para aplicar la nueva versión.',
      showTextarea: false,
      confirmar: 'Actualizar',
      cancelar: 'Cancelar'
    })
    if (!confirmed) return
    this.isUpdating.set(true)
    await this.pwaUpdate.applyUpdate()
  }
}
